import { useSelector, useDispatch } from 'react-redux';
import FJVideoRemoveBgCustomExport from '../view/FJVideoRemoveBgCustomExport';
import { useCallback } from 'react';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJVideoRemoveBgAutoExportAfterContainer = () => {
    const dispatch = useDispatch();
    const status = useSelector(state => state.videoBgRemover.autoExportData.exportStatus);
    const progress = useSelector(state => state.videoBgRemover.autoExportData.exportProgress);
    const isApplyButton = useSelector(state => state.common.isApplyButton);

    const download = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoExportVideoAction());
    }, [dispatch]);

    const goToBack = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoCancelExportVideoAction());
    }, [dispatch]);

    const cancelExport = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoCancelExportVideoAction());
    }, [dispatch]);

    const removeMore = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadAutoEditVideoAction(file));
        },
        [dispatch],
    );

    const _onEdit = () => {
        dispatch(FJActionVideoRemoveBg.onEditAction());
    };

    const _onClick = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJVideoRemoveBgCustomExport
            status={status}
            progress={progress}
            download={download}
            goToBack={goToBack}
            cancelExport={cancelExport}
            removeMore={removeMore}
            onEdit={_onEdit}
            onClick={_onClick}
            isApplyButton={isApplyButton}
        />
    );
};

export default FJVideoRemoveBgAutoExportAfterContainer;
